// extracted by mini-css-extract-plugin
export default {"verdictWrapper":"WnGHxzma","mobile":"mobile","verdictTitle":"hxpvZUkm","text":"HZJMhYfW"};